module.exports = __webpack_public_path__ + "static/the-lancashire-hotpots-tour-de-source-carousel-image-183e5e57f89f20bde49e3fcbe239ff13.jpg";